import React, { ReactElement, useRef } from 'react';
import { formatTranslation } from 'intl';
import { CommonTranslationKeys } from 'intl/keys';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import {
  floatingToolbarSx,
  floatingToolbarCountSx,
  floatingToolbarIconSx,
  floatingToolbarCloseIconSx,
} from './styles';

export interface ToolbarAction {
  label: string;
  icon: ReactElement;
  onClick: () => void;
  disabled?: boolean;
}

interface FloatingToolbarProps {
  selectedCount: number;
  actions: ToolbarAction[];
  onClearSelection: () => void;
}

export function FloatingToolbar({
  selectedCount,
  actions,
  onClearSelection,
}: FloatingToolbarProps): ReactElement {
  const intl = useIntl();
  const visible = selectedCount > 0;
  const lastCountRef = useRef(selectedCount);
  if (selectedCount > 0) {
    lastCountRef.current = selectedCount;
  }
  const displayCount = visible ? selectedCount : lastCountRef.current;

  return (
    <Box sx={floatingToolbarSx(visible)}>
      <Typography variant='body2' sx={floatingToolbarCountSx}>
        {formatTranslation(intl, CommonTranslationKeys.dataGridActionsSelectedCount, { count: displayCount })}
      </Typography>
      {actions.map((action) => (
        <Tooltip key={action.label} title={action.label}>
          <span>
            <IconButton
              size='small'
              onClick={action.onClick}
              disabled={action.disabled}
              sx={floatingToolbarIconSx}
            >
              {action.icon}
            </IconButton>
          </span>
        </Tooltip>
      ))}
      <Tooltip title={formatTranslation(intl, CommonTranslationKeys.cancel)}>
        <IconButton
          size='small'
          onClick={onClearSelection}
          sx={floatingToolbarCloseIconSx}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
